import React from "react";
import {Query, Loading} from "../../components";
import TestDescription from "./TestDescription";
import TestStart from "./TestStart";
import { getPracticeTest, submitPracticeTest } from "../../lib/api";
import RecruitmentTest from "./RecruitmentTest";

const Test = ({
  match: {
    params: { qid }
  },
  location: { search }
}) => {
  return (
    <>
      <Query query={() => getPracticeTest(search)}>
        {({ loading, data }) => {
          let testData = data.data;
          if (loading) {
            return <Loading />;
          }
          return data.subject_id == 136 ? <RecruitmentTest></RecruitmentTest>
          :
          !qid ? (
            <TestDescription search={search} {...testData} />
          ) : (
            <TestStart {...testData} {...{ qid, search }} submitTest={submitPracticeTest} />
          );
        }}
      </Query>
    </>
  );
};

export default Test;
